function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;
export { _cacheHas as _ };